import { post, } from "../helpers/apiHelper";

async function searchVideoSubscriptions(params) {
    return await post(`orders/videoSubscriptions`, params);
}

export default {
    searchVideoSubscriptions
}